var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0903 20.1163V14.818C13.0903 14.5838 12.9993 14.3592 12.8373 14.1936C12.6754 14.028 12.4557 13.935 12.2266 13.935H8.77209C8.54304 13.935 8.32337 14.028 8.16141 14.1936C7.99945 14.3592 7.90846 14.5838 7.90846 14.818V20.1163C7.90846 20.3504 7.81748 20.575 7.65554 20.7406C7.4936 20.9062 7.27396 20.9993 7.04493 20.9993L1.86374 21C1.75032 21 1.63801 20.9772 1.53321 20.9328C1.42842 20.8884 1.3332 20.8234 1.25299 20.7414C1.17278 20.6594 1.10916 20.5621 1.06575 20.4549C1.02234 20.3478 1 20.2329 1 20.117V9.91136C1 9.78834 1.02514 9.66667 1.07381 9.55416C1.12249 9.44165 1.19361 9.34079 1.28264 9.25802L9.91841 1.22969C10.0774 1.0819 10.2845 1.00001 10.4994 1C10.7142 0.999993 10.9214 1.08187 11.0804 1.22965L19.7173 9.25802C19.8064 9.34078 19.8775 9.44166 19.9262 9.55417C19.9749 9.66669 20 9.78836 20 9.91139V20.117C20 20.2329 19.9777 20.3478 19.9342 20.4549C19.8908 20.5621 19.8272 20.6594 19.747 20.7414C19.6668 20.8234 19.5716 20.8884 19.4668 20.9328C19.362 20.9772 19.2497 21 19.1363 21L13.9538 20.9993C13.7248 20.9993 13.5051 20.9062 13.3432 20.7406C13.1812 20.575 13.0903 20.3504 13.0903 20.1163Z",
    stroke: "#CDCEC8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.4cc54e94.svg";
export { ForwardRef as ReactComponent };